module.exports = __webpack_public_path__ + "img/new_two.21961083.jpeg";